import { render, staticRenderFns } from "./USortingUpDown.vue?vue&type=template&id=3248e167"
import script from "./USortingUpDown.vue?vue&type=script&lang=js"
export * from "./USortingUpDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports